<template>
  <div class="total pointer" @mouseleave="mouseLeave" @mouseenter="mouseEnter">
      <div class="img">
        <img :src="items.image" alt="">
         <div v-show="flag" class="board-total">
            <div class="total-name">{{items.name}}</div>
            <div class="total-instruction flex-align wes-7 ">{{items.instruction}}</div>
        </div>
    </div>
    <div class="name">{{items.name}}</div>
   
  </div>
</template>

<script>
export default {
    props:['items'],
    data(){
        return{
           flag:false,
        }
    },
    methods:{
       mouseEnter() {
        this.flag =true;
      },
       mouseLeave() {
        this.flag =false;

      },
    },
    mounted(){
    }
};
</script>

<style lang="less">
.total {
    .img {
        position: relative;
        border: 1px solid #E9E9E9;
        border-radius: 5px;
        padding:8px;
        //  width: 152px;
        height: 214px;
            img {
            width: 100%;
            height: 100%;
            
            }
            .board-total {
            position: absolute;
            width: 148px;
            height: 214px;
            top: 8px;
            left: 8px;
            background-color: rgba(188, 146,82, .8);
            .total-name {
                color: #fff;
                text-align:center;
                padding:15px 0;
                font-size:16px;
            }
            .total-instruction {
                color: #fff;
                font-size:14px;
                padding:0 10px;
                line-height: 20px;
            }

            }
        }

    .name {
        padding-top:10px;
        text-align: center;
    }

}

</style>